/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_YearInputs */

const de__field_year = /** @type {(inputs: _Field_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schuljahr`)
};

/**

* @param {_Field_YearInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_year = /** @type {((inputs?: _Field_YearInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_YearInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_year(inputs)
});